"use client";

import { Menu } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { useHashNavigation } from "@/hooks/use-hash-navigation";
import { generateWhatsAppLink } from "@/lib/generateWhatsappLink";

export function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useHashNavigation();

  const menuItems = [
    { label: "Início", href: "/" },
    { label: "Serviços", href: "/#servicos" },
    { label: "Sobre", href: "/#sobre" },
    { label: "Depoimentos", href: "/#depoimentos" },
    { label: "FAQ", href: "/#faq" },
    { label: "Blog", href: "/blog" },
    { label: "Contato", href: "/#contato" },
  ];

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="hover:bg-primary/10 absolute left-4 rounded-lg p-2 transition-colors md:hidden"
      >
        <Menu className="text-foreground h-6 w-6" />
      </button>

      {isOpen && (
        <div
          className="fixed inset-0 z-40 h-screen bg-black/40 backdrop-blur-sm md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      <div
        className={`bg-background border-border fixed top-0 left-0 z-50 flex h-screen w-64 transform flex-col border-r shadow-xl transition-transform duration-300 ease-out md:hidden ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex items-center justify-center p-4">
          <Image
            src="/logo-v2.png"
            alt="São Chico - Clinica Veterinária"
            width={800}
            height={500}
            className={`h-auto w-40`}
            priority
            quality={100}
          />
        </div>

        <nav className="flex flex-col gap-2 px-2 pt-4">
          {menuItems.map((item) => (
            <button
              key={item.href}
              onClick={() => {
                setIsOpen(false);
                navigate(item.href);
              }}
              className="text-foreground hover:bg-primary/10 rounded-lg px-4 py-2 text-start font-semibold transition-colors"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="p-4">
          <Button size="xl" asChild>
            <Link
              href={generateWhatsAppLink(
                process.env.NEXT_PUBLIC_WHATSAPP_NUMBER || "",
                "Olá! Gostaria de mais informações sobre os serviços da Clínica São Chico.",
              )}
              target="_blank"
              rel="noopener noreferrer"
              className="uppercaseflex w-full items-center gap-2"
            >
              <Image
                src="/whatsapp-icon.svg"
                alt="WhatsApp Icon"
                width={20}
                height={20}
                className="h-5 w-5"
              />{" "}
              Agendar Consulta
            </Link>
          </Button>
        </div>
      </div>
    </>
  );
}
